/** Paths of the admin pages, for links between them */
export const ADMIN_PATHS = {
  PROFILES: '/profile',
  USERS: '/user',
  CONSOLIDATIONS: '/consolidation',
  AUDIT_LOG: '/audit-log',
  LINK_SHORTENER: '/link-shortener',
  ML: '/ml'
} as const;

/** Tabs of the profile detail, the `tab` query parameter */
export type ProfileTab = 'overview' | 'subscriptions' | 'consolidation' | 'audit-log';

/** Tabs of the user detail, the `tab` query parameter */
export type UserTab = 'profiles' | 'audit-log';

export function getProfilePath(profileId: number): string {
  return `${ADMIN_PATHS.PROFILES}/${profileId}`;
}

/** New profile, or a clone of the given one */
export function getNewProfilePath(cloneFromId?: number): string {
  return cloneFromId ? `${ADMIN_PATHS.PROFILES}/new?cloneFrom=${cloneFromId}` : `${ADMIN_PATHS.PROFILES}/new`;
}

export function getUserPath(userId: number): string {
  return `${ADMIN_PATHS.USERS}/${userId}`;
}
